"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BudgetResponseToJSON = exports.BudgetResponseFromJSONTyped = exports.BudgetResponseFromJSON = exports.instanceOfBudgetResponse = void 0;
var runtime_1 = require("../runtime");
var BudgetRequest_1 = require("./BudgetRequest");
/**
 * Check if a given object implements the BudgetResponse interface.
 */
function instanceOfBudgetResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfBudgetResponse = instanceOfBudgetResponse;
function BudgetResponseFromJSON(json) {
    return BudgetResponseFromJSONTyped(json, false);
}
exports.BudgetResponseFromJSON = BudgetResponseFromJSON;
function BudgetResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return __assign(__assign({}, (0, BudgetRequest_1.BudgetRequestFromJSONTyped)(json, ignoreDiscriminator)), { 'currency': !(0, runtime_1.exists)(json, 'currency') ? undefined : json['currency'] });
}
exports.BudgetResponseFromJSONTyped = BudgetResponseFromJSONTyped;
function BudgetResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return __assign({}, (0, BudgetRequest_1.BudgetRequestToJSON)(value));
}
exports.BudgetResponseToJSON = BudgetResponseToJSON;
